import React from 'react';
import Styled from 'styled';
import { FormattedMessage } from 'react-intl';

import TextShortener from 'four-nets/ui-v2/text-shortener/text-shortener';
import EnhancedText from 'four-nets/ui/enhanced-text/enhanced-text';

import defaultStyles from './description-content.scss';

export interface Props {
    styles: typeof defaultStyles;
    content: string;
    isVendor?: boolean | null;
    isPrArticle?: boolean;
}

interface State {
    showMore: boolean;
}

class DescriptionContent extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            showMore: false,
        };
    }

    render() {
        const { styles, content, isVendor, isPrArticle } = this.props;

        return (
            <div className={styles.content}>
                <TextShortener text={content || ''} words={this.state.showMore ? undefined : 25}>
                    {text => (
                        <React.Fragment>
                            <EnhancedText followLink={Boolean(isVendor) || isPrArticle}>{text}</EnhancedText>
                            {content !== text || this.state.showMore ? (
                                <button
                                    className={styles.showMore}
                                    onClick={() => this.setState(prevState => ({ showMore: !prevState.showMore }))}
                                >
                                    {this.state.showMore ? <FormattedMessage id='BUTTON_SHOW_LESS' /> : null}
                                    {!this.state.showMore && content !== text ? (
                                        <FormattedMessage id='BUTTON_SHOW_MORE' />
                                    ) : null}
                                </button>
                            ) : null}
                        </React.Fragment>
                    )}
                </TextShortener>
            </div>
        );
    }
}

export default Styled(defaultStyles)(DescriptionContent);
